import { Component } from '@angular/core';

@Component({
  selector: 'ps-decipher',
  templateUrl: './decipher.component.html',
  styleUrls: ['./decipher.component.css'],
})
export class DecipherComponent {}
